import React, { FC } from 'react';
import { VideoBackgroundRenderer } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan/components/HeaderV2/layouts';
import { PhotoArch } from '../PhotoArch/PhotoArch';
import { VideoArchProps } from './VideoArch.types';
import { Box } from '@withjoy/joykit';

export const VideoArch: FC<VideoArchProps> = ({ photoProps, videoProps, renderWrapper }) => {
  const context = { photoProps, videoProps };

  const photoArchContent = (
    <PhotoArch
      {...photoProps}
      isFullHeight={false}
    />
  );

  // Add support for custom wrappers like inline editor
  const wrappedContent = renderWrapper ? (
    renderWrapper(photoArchContent, context)
  ) : (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="docked"
    >
      {photoArchContent}
    </Box>
  );

  const hasContent = videoProps.videoUrl || videoProps.thumbnailUrl;

  return (
    <Box
      position="relative"
      height={videoProps.height ?? '100vh'}
    >
      {hasContent ? (
        <VideoBackgroundRenderer {...videoProps}>{wrappedContent}</VideoBackgroundRenderer>
      ) : (
        <Box>
          <Box
            position="absolute"
            top={0}
            width="100vw"
            height="100vh"
            backgroundColor={videoProps.showPlaceholder ? 'lightgray' : photoProps.innerArchColor}
            zIndex="base"
            overflow="hidden"
            left="calc(-50vw + 50%)"
          />
          {wrappedContent}
        </Box>
      )}
    </Box>
  );
};
